import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  points: 0,
  transactions: [],
  minCapPoints: 0,
};
const pointSlice = createSlice({
  name: "point",
  initialState,
  reducers: {
    setPointBalance: (state, action) => {
      state.points = action.payload;
    },
    addPoints: (state, action) => {
      state.points += action.payload;
    },
    deductPoints: (state, action) => {
      state.points = Math.max(0, state.points - action.payload);
    },
    setTransactions: (state, action) => {
      state.transactions = action.payload;
    },
    // convertPointsToCurrency: (state, action) => {
    //   const rupees = (action.payload / 200) * 2;
    //   if (state.points >= action.payload) {
    //     state.points -= action.payload;

    //   }
    // },
    convertPointsToCurrency: (state, action) => {
      const pointsToUse = action.payload;
      const conversionCap = state.minCapPoints || 200; // fallback to 200 if not set

      if (state.points >= pointsToUse && state.points >= conversionCap) {
        state.points -= pointsToUse;
      }
    },

    setMinCapPoints: (state, action) => {
      state.minCapPoints = action.payload;
    },
    setDefaultPointData: (state, action) => {
      return initialState;
    },
  },
});

export const {
  setPointBalance,
  addPoints,
  deductPoints,
  setTransactions,
  setMinCapPoints,
  convertPointsToCurrency,
  setDefaultPointData,
} = pointSlice.actions;

export default pointSlice.reducer;
